import classNames from "classnames";
import { Field } from "react-final-form";

import Radio from "@components/Form/Radio";

const RcaOffersPolicyType = ({ values }) => (
  <>
    <div
      className={classNames("flex items-center p-[16px] bg-white", {
        "border border-[#99CE88]": values?.withDirectSettlement === "Yes",
      })}
    >
      <Field
        name="withDirectSettlement"
        type="radio"
        value="Yes"
        component={Radio}
        label="Cu decontare directa"
        className={classNames("cursor-pointer w-full mb-0", {
          "pointer-events-none cursor-default": values.legalType === "PF",
        })}
        labelClass="font-normal text-[14px]"
      />
    </div>

    <div
      className={classNames("flex items-center p-[16px] bg-white", {
        "border border-[#99CE88]": values?.withDirectSettlement === "No",
      })}
    >
      <Field
        name="withDirectSettlement"
        type="radio"
        value="No"
        component={Radio}
        label="Fara decontare directa"
        className={classNames("cursor-pointer w-full mb-0", {
          "pointer-events-none cursor-default": values.legalType === "PJ",
        })}
        labelClass="font-normal text-[14px]"
      />
    </div>
  </>
);

export default RcaOffersPolicyType;
